import { createEffect } from 'effector'
import { ContentTypeParams, SeoMetadataParams } from '../../index.h'
import { stateful } from '../../lib/stateful'
import { type Tag } from './index.h'

export { type Tag }

type GetOneParams = { id: number }
type IdsParams = { ids?: number[] }
type PageParams = { limit?: number; offset?: number }
type SortParams = { by?: string; order?: string }
type FilterParams = { q?: string; hasContent?: boolean }
type GetManyParams = IdsParams & PageParams & SortParams & FilterParams

// *
// * base API effects
// *

export const base = {
  getOneFx: createEffect<
    GetOneParams & ContentTypeParams & SeoMetadataParams,
    Tag
  >(),
  getManyFx: createEffect<GetManyParams, Tag[]>(),
  getManySpecialFx: createEffect<PageParams, Tag[]>(),
}

// *
// *
// *

export const pageable = (initial?: GetManyParams) =>
  stateful({
    effect: base.getManyFx,
    initial,
    methods: {
      limit: (n: number) => ({ limit: n }),
      offset: (n: number) => ({ offset: n }),
      next: (_: void, { offset = 0, limit = 36 }) => ({
        offset: offset + limit,
      }),
      prev: (_: void, { offset = 0, limit = 36 }) => ({
        offset: Math.max(offset - limit, 0),
      }),
      sort: ({ by, order }: SortParams) => ({ by, order }),
      by: (by: string | undefined) => ({ by }),
      order: (order: string | undefined) => ({ order }),
      filter: ({ q, hasContent }: FilterParams) => ({ q, hasContent }),
    },
  })

export const specialPageable = (initial?: PageParams) =>
  stateful({
    effect: base.getManySpecialFx,
    initial,
    methods: {
      limit: (n: number) => ({ limit: n }),
      offset: (n: number) => ({ offset: n }),
      next: (_: void, { offset = 0, limit = 36 }) => ({
        offset: offset + limit,
      }),
      prev: (_: void, { offset = 0, limit = 36 }) => ({
        offset: Math.max(offset - limit, 0),
      }),
    },
  })
